import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import { assert, isHexString } from "../utils/index.js";
function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
/**
 *  Return the polling subscriber for common events.
 *
 *  @_docloc: api/providers/abstract-provider
 */
export function getPollingSubscriber(provider, event) {
  if (event === "block") {
    return new PollingBlockSubscriber(provider);
  }
  if (isHexString(event, 32)) {
    return new PollingTransactionSubscriber(provider, event);
  }
  assert(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
    operation: "getPollingSubscriber",
    info: {
      event: event
    }
  });
}
// @TODO: refactor this
/**
 *  A **PollingBlockSubscriber** polls at a regular interval for a change
 *  in the block number.
 *
 *  @_docloc: api/providers/abstract-provider
 */
var _provider = /*#__PURE__*/new WeakMap();
var _poller = /*#__PURE__*/new WeakMap();
var _interval = /*#__PURE__*/new WeakMap();
var _blockNumber = /*#__PURE__*/new WeakMap();
var _poll = /*#__PURE__*/new WeakSet();
export var PollingBlockSubscriber = /*#__PURE__*/function () {
  // The most recent block we have scanned for events. The value -2
  // indicates we still need to fetch an initial block number

  /**
   *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
   */
  function PollingBlockSubscriber(provider) {
    _classCallCheck(this, PollingBlockSubscriber);
    _classPrivateMethodInitSpec(this, _poll);
    _classPrivateFieldInitSpec(this, _provider, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _poller, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _interval, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _blockNumber, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _provider, provider);
    _classPrivateFieldSet(this, _poller, null);
    _classPrivateFieldSet(this, _interval, 4000);
    _classPrivateFieldSet(this, _blockNumber, -2);
  }
  /**
   *  The polling interval.
   */
  _createClass(PollingBlockSubscriber, [{
    key: "pollingInterval",
    get: function get() {
      return _classPrivateFieldGet(this, _interval);
    },
    set: function set(value) {
      _classPrivateFieldSet(this, _interval, value);
    }
  }, {
    key: "start",
    value: function start() {
      if (_classPrivateFieldGet(this, _poller)) {
        return;
      }
      _classPrivateFieldSet(this, _poller, _classPrivateFieldGet(this, _provider)._setTimeout(_classPrivateMethodGet(this, _poll, _poll2).bind(this), _classPrivateFieldGet(this, _interval)));
      _classPrivateMethodGet(this, _poll, _poll2).call(this);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!_classPrivateFieldGet(this, _poller)) {
        return;
      }
      _classPrivateFieldGet(this, _provider)._clearTimeout(_classPrivateFieldGet(this, _poller));
      _classPrivateFieldSet(this, _poller, null);
    }
  }, {
    key: "pause",
    value: function pause(dropWhilePaused) {
      this.stop();
      if (dropWhilePaused) {
        _classPrivateFieldSet(this, _blockNumber, -2);
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start();
    }
  }]);
  return PollingBlockSubscriber;
}();
/**
 *  An **OnBlockSubscriber** can be sub-classed, with a [[_poll]]
 *  implmentation which will be called on every new block.
 *
 *  @_docloc: api/providers/abstract-provider
 */
function _poll2() {
  return _poll9.apply(this, arguments);
}
function _poll9() {
  _poll9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var blockNumber, b;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return _classPrivateFieldGet(this, _provider).getBlockNumber();
        case 3:
          blockNumber = _context4.sent;
          if (!(_classPrivateFieldGet(this, _blockNumber) === -2)) {
            _context4.next = 7;
            break;
          }
          _classPrivateFieldSet(this, _blockNumber, blockNumber);
          return _context4.abrupt("return");
        case 7:
          if (!(blockNumber !== _classPrivateFieldGet(this, _blockNumber))) {
            _context4.next = 18;
            break;
          }
          b = _classPrivateFieldGet(this, _blockNumber) + 1;
        case 9:
          if (!(b <= blockNumber)) {
            _context4.next = 17;
            break;
          }
          if (!(_classPrivateFieldGet(this, _poller) == null)) {
            _context4.next = 12;
            break;
          }
          return _context4.abrupt("return");
        case 12:
          _context4.next = 14;
          return _classPrivateFieldGet(this, _provider).emit("block", b);
        case 14:
          b++;
          _context4.next = 9;
          break;
        case 17:
          _classPrivateFieldSet(this, _blockNumber, blockNumber);
        case 18:
          _context4.next = 22;
          break;
        case 20:
          _context4.prev = 20;
          _context4.t0 = _context4["catch"](0);
        case 22:
          if (!(_classPrivateFieldGet(this, _poller) == null)) {
            _context4.next = 24;
            break;
          }
          return _context4.abrupt("return");
        case 24:
          _classPrivateFieldSet(this, _poller, _classPrivateFieldGet(this, _provider)._setTimeout(_classPrivateMethodGet(this, _poll, _poll2).bind(this), _classPrivateFieldGet(this, _interval)));
        case 25:
        case "end":
          return _context4.stop();
      }
    }, _callee4, this, [[0, 20]]);
  }));
  return _poll9.apply(this, arguments);
}
var _provider2 = /*#__PURE__*/new WeakMap();
var _poll3 = /*#__PURE__*/new WeakMap();
var _running = /*#__PURE__*/new WeakMap();
export var OnBlockSubscriber = /*#__PURE__*/function () {
  /**
   *  Create a new **OnBlockSubscriber** attached to %%provider%%.
   */
  function OnBlockSubscriber(provider) {
    var _this = this;
    _classCallCheck(this, OnBlockSubscriber);
    _classPrivateFieldInitSpec(this, _provider2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _poll3, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _running, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _provider2, provider);
    _classPrivateFieldSet(this, _running, false);
    _classPrivateFieldSet(this, _poll3, function (blockNumber) {
      _this._poll(blockNumber, _classPrivateFieldGet(_this, _provider2));
    });
  }
  /**
   *  Called on every new block.
   */
  _createClass(OnBlockSubscriber, [{
    key: "_poll",
    value: function () {
      var _poll4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blockNumber, provider) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              throw new Error("sub-classes must override this");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function _poll(_x, _x2) {
        return _poll4.apply(this, arguments);
      }
      return _poll;
    }()
  }, {
    key: "start",
    value: function start() {
      if (_classPrivateFieldGet(this, _running)) {
        return;
      }
      _classPrivateFieldSet(this, _running, true);
      _classPrivateFieldGet(this, _poll3).call(this, -2);
      _classPrivateFieldGet(this, _provider2).on("block", _classPrivateFieldGet(this, _poll3));
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!_classPrivateFieldGet(this, _running)) {
        return;
      }
      _classPrivateFieldSet(this, _running, false);
      _classPrivateFieldGet(this, _provider2).off("block", _classPrivateFieldGet(this, _poll3));
    }
  }, {
    key: "pause",
    value: function pause(dropWhilePaused) {
      this.stop();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start();
    }
  }]);
  return OnBlockSubscriber;
}();
/**
 *  @_ignore:
 *
 *  @_docloc: api/providers/abstract-provider
 */
var _filter = /*#__PURE__*/new WeakMap();
export var PollingOrphanSubscriber = /*#__PURE__*/function (_OnBlockSubscriber) {
  _inherits(PollingOrphanSubscriber, _OnBlockSubscriber);
  var _super = _createSuper(PollingOrphanSubscriber);
  function PollingOrphanSubscriber(provider, filter) {
    var _this2;
    _classCallCheck(this, PollingOrphanSubscriber);
    _this2 = _super.call(this, provider);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this2), _filter, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this2), _filter, copy(filter));
    return _this2;
  }
  _createClass(PollingOrphanSubscriber, [{
    key: "_poll",
    value: function () {
      var _poll5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blockNumber, provider) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error("@TODO");
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _poll(_x3, _x4) {
        return _poll5.apply(this, arguments);
      }
      return _poll;
    }()
  }]);
  return PollingOrphanSubscriber;
}(OnBlockSubscriber);
/**
 *  A **PollingTransactionSubscriber** will poll for a given transaction
 *  hash for its receipt.
 *
 *  @_docloc: api/providers/abstract-provider
 */
var _hash = /*#__PURE__*/new WeakMap();
export var PollingTransactionSubscriber = /*#__PURE__*/function (_OnBlockSubscriber2) {
  _inherits(PollingTransactionSubscriber, _OnBlockSubscriber2);
  var _super2 = _createSuper(PollingTransactionSubscriber);
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%hash%%.
   */
  function PollingTransactionSubscriber(provider, hash) {
    var _this3;
    _classCallCheck(this, PollingTransactionSubscriber);
    _this3 = _super2.call(this, provider);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this3), _hash, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this3), _hash, hash);
    return _this3;
  }
  _createClass(PollingTransactionSubscriber, [{
    key: "_poll",
    value: function () {
      var _poll6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(blockNumber, provider) {
        var tx;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return provider.getTransactionReceipt(_classPrivateFieldGet(this, _hash));
            case 2:
              tx = _context3.sent;
              if (tx) {
                provider.emit(_classPrivateFieldGet(this, _hash), tx);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _poll(_x5, _x6) {
        return _poll6.apply(this, arguments);
      }
      return _poll;
    }()
  }]);
  return PollingTransactionSubscriber;
}(OnBlockSubscriber);
/**
 *  A **PollingEventSubscriber** will poll for a given filter for its logs.
 *
 *  @_docloc: api/providers/abstract-provider
 */
var _provider3 = /*#__PURE__*/new WeakMap();
var _filter2 = /*#__PURE__*/new WeakMap();
var _poller2 = /*#__PURE__*/new WeakMap();
var _running2 = /*#__PURE__*/new WeakMap();
var _blockNumber2 = /*#__PURE__*/new WeakMap();
var _poll7 = /*#__PURE__*/new WeakSet();
export var PollingEventSubscriber = /*#__PURE__*/function () {
  // The most recent block we have scanned for events. The value -2
  // indicates we still need to fetch an initial block number

  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%filter%%.
   */
  function PollingEventSubscriber(provider, _filter3) {
    _classCallCheck(this, PollingEventSubscriber);
    _classPrivateMethodInitSpec(this, _poll7);
    _classPrivateFieldInitSpec(this, _provider3, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _filter2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _poller2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _running2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _blockNumber2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _provider3, provider);
    _classPrivateFieldSet(this, _filter2, copy(_filter3));
    _classPrivateFieldSet(this, _poller2, _classPrivateMethodGet(this, _poll7, _poll8).bind(this));
    _classPrivateFieldSet(this, _running2, false);
    _classPrivateFieldSet(this, _blockNumber2, -2);
  }
  _createClass(PollingEventSubscriber, [{
    key: "start",
    value: function start() {
      var _this4 = this;
      if (_classPrivateFieldGet(this, _running2)) {
        return;
      }
      _classPrivateFieldSet(this, _running2, true);
      if (_classPrivateFieldGet(this, _blockNumber2) === -2) {
        _classPrivateFieldGet(this, _provider3).getBlockNumber().then(function (blockNumber) {
          _classPrivateFieldSet(_this4, _blockNumber2, blockNumber);
        });
      }
      _classPrivateFieldGet(this, _provider3).on("block", _classPrivateFieldGet(this, _poller2));
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!_classPrivateFieldGet(this, _running2)) {
        return;
      }
      _classPrivateFieldSet(this, _running2, false);
      _classPrivateFieldGet(this, _provider3).off("block", _classPrivateFieldGet(this, _poller2));
    }
  }, {
    key: "pause",
    value: function pause(dropWhilePaused) {
      this.stop();
      if (dropWhilePaused) {
        _classPrivateFieldSet(this, _blockNumber2, -2);
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start();
    }
  }]);
  return PollingEventSubscriber;
}();
function _poll8(_x7) {
  return _poll10.apply(this, arguments);
}
function _poll10() {
  _poll10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(blockNumber) {
    var filter, logs, _iterator, _step, log;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!(_classPrivateFieldGet(this, _blockNumber2) === -2)) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("return");
        case 2:
          filter = copy(_classPrivateFieldGet(this, _filter2));
          filter.fromBlock = _classPrivateFieldGet(this, _blockNumber2) + 1;
          filter.toBlock = blockNumber;
          _context5.next = 7;
          return _classPrivateFieldGet(this, _provider3).getLogs(filter);
        case 7:
          logs = _context5.sent;
          if (!(logs.length === 0)) {
            _context5.next = 11;
            break;
          }
          if (_classPrivateFieldGet(this, _blockNumber2) < blockNumber - 60) {
            _classPrivateFieldSet(this, _blockNumber2, blockNumber - 60);
          }
          return _context5.abrupt("return");
        case 11:
          _iterator = _createForOfIteratorHelper(logs);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              log = _step.value;
              _classPrivateFieldGet(this, _provider3).emit(_classPrivateFieldGet(this, _filter2), log);
              // Only advance the block number when logs were found to
              // account for networks (like BNB and Polygon) which may
              // sacrifice event consistency for block event speed
              _classPrivateFieldSet(this, _blockNumber2, log.blockNumber);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        case 13:
        case "end":
          return _context5.stop();
      }
    }, _callee5, this);
  }));
  return _poll10.apply(this, arguments);
}